import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

import ImageSlider from "./elements/ImageSlider"

const StudioSliderStart = ({ className }) => {
  const { images } = useStaticQuery(graphql`
    query {
      images: contentfulImageSlider(
        contentful_id: { eq: "3xLBRs2ZkB2zZq4vi77mk2" }
      ) {
        id
        images {
          ... on ContentfulAsset {
            id
            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
          }
        }
      }
    }
  `)

  return (
    <>
      <div className={className}>
        <ImageSlider images={images.images} height={250} />
        <div className="d-flex justify-content-center mt-5">
          <Link
            to="/kurse"
            className="btn btn-outline-primary"
            style={{ borderRadius: "25px" }}
          >
            Jetzt selbst kreativ werden!
          </Link>
        </div>
      </div>
      <hr style={{ margin: "5rem 0" }} />
    </>
  )
}

export default StudioSliderStart
